/**
 * React product page
 * =============================================================================
 *
 *
 * Imports
 * ------------------------------------------------------------------------------
 */

//import { addToCart, changeCart, updateCartContainer } from './../cartFunctions'
//import { formatMoney } from '@shopify/theme-currency';
import builderPrintShopHeader from '../builders/builderPrintShopHeader';
import builderPrintShopFooter from '../builders/builderPrintShopFooter';

/**
 * Get Print Shop Partner Header
 * ------------------------------------------------------------------------------
 */

//const partnerID = window.partner
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
var partnerUTM = urlParams.get('partner');

const partner = localStorage.getItem('partner');
const frameologyHeader = document.getElementById('shopify-section-header');
const MainContent = document.getElementById('MainContent');
const FooterSection = document.getElementById('shopify-section-footer');
const FOMFooter = FooterSection.querySelector('.main-footer');
const body = document.body;

frameologyHeader.style.display = 'none';

if (partner && partner == partnerUTM) {
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;

    if (url.includes('partner')) {
    } else {
      if (url !== lastUrl) {
        lastUrl = url;
        onUrlChange(lastUrl);
      }
    }
  }).observe(document, { subtree: true, childList: true });

  function onUrlChange(lastUrl) {
    const newURL = lastUrl;
    const newURLUTM = '&partner=' + partner + '';
    const partnerURL = newURL + newURLUTM;
    console.log(partnerURL);
    window.history.replaceState('', '', partnerURL);
  }

  frameologyHeader.remove();

  window.buildPrintShopHeader = buildPrintShopHeader;

  async function buildPrintShopHeader() {
    let header = null;

    await fetch(`/cart.js`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */,
      },
      method: 'GET',
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        header = builderPrintShopHeader(data);
      });

    return header;
  }

  buildPrintShopHeader().then((html) => {
    MainContent.insertAdjacentHTML('beforebegin', html);
    reattachEvents(body);
    builderNavLinks();
    updateCartShopBTN();
  });

  const builderNavLinks = () => {
    const desktopLinkContainer = document.getElementById('desktop-about-link');
    const mobileLinkContainer = document.getElementById('mobile-about-link');
    const partnerCollectionID = partner.replace(/\-/g, '');
    const partnerCollectionsArray = window[partnerCollectionID + 'Collections'];
    const partnerCollections = Array.from(partnerCollectionsArray);

    let collectionHandle = '';
    let collectionTitle = '';
    let collectionLink = '';

    partnerCollections.forEach((collection) => {
      var collections = collection.split(':');
      var collectionHandle = collections[0];
      var collectionTitle = collections[1];

      var collectionLinkDesktop = `
        <button class="main-header__nav-header-dt">
          <span class="typo__header typo__header--medium">
            <a
              href="/collections/${collectionHandle}"
             >${collectionTitle}</a>
          </span>      
        </button>   
      `;
      var collectionLinkMobile = `
        <li class="main-header__mobile-menu-item">
          <a class="main-header__mobile-menu-link typo__paragraph typo__paragraph--big" href="/collections/${collectionHandle}" >${
        collectionTitle == 'Your photos'
          ? 'Frame your photos'
          : collectionTitle == 'Mets art'
          ? 'Shop Mets wall art'
          : collectionTitle
      }</a>
        </li>        
      `;
      desktopLinkContainer.insertAdjacentHTML('beforebegin', collectionLinkDesktop);
      mobileLinkContainer.insertAdjacentHTML('beforebegin', collectionLinkMobile);
    });
  };

  const updateCartShopBTN = () => {
    const printShopURL = document.querySelector('.main-header__logo');
    const contShopBTN = document.querySelector('.cart-ovrl__continue-shopping');

    contShopBTN.setAttribute('href', printShopURL);
  };

  /**
   * ReEnable Header Events
   * ------------------------------------------------------------------------------
   */
  const reattachEvents = () => {
    const cartToggler = document.getElementById('fn-cart-toggler');
    const burger = document.getElementById('fn-burger');

    cartToggler &&
      cartToggler.addEventListener('click', (e) => {
        const getCartCount = Number(window.getCartCount);

        if (getCartCount >= 1) {
          body.classList.toggle('cart-opened');

          const discountBar = document.querySelector('.cart-ovrl__discount-bar');

          if (discountBar) {
            setTimeout(function () {
              discountBar.classList.toggle('cart-opened');
            }, 500);
          }
        }
      });

    const closeCartBtns = Array.from(document.querySelectorAll('.fn-cart-close'));

    if (closeCartBtns && closeCartBtns.length > 0) {
      closeCartBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          document.body.classList.remove('cart-opened');
          const discountBar = document.querySelector('.cart-ovrl__discount-bar');

          if (discountBar) {
            discountBar.classList.remove('cart-opened');
          }
        });
      });
    }

    burger &&
      burger.addEventListener('click', () => {
        document.body.classList.toggle('show-menu');
      });
  };

  const footer = builderPrintShopFooter();
  FOMFooter.remove();
  FooterSection.insertAdjacentHTML('beforeend', footer);
} else {
  frameologyHeader.style.display = 'block';
  body.classList.remove('print-shop');
}

/**
 * Recently viewed
 * ------------------------------------------------------------------------------
 */

const handle = document.getElementById('MainContent').getAttribute('data-handle');

const setCookie = (key, value) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 days
  document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/';
};

const getCookie = (key) => {
  const keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
};

// Get recently viewed from cookies (unless it is gift card prod page)

let rvHandles = getCookie('fr_rv') ? getCookie('fr_rv').split('|') : [];

// Prepare new array

const elIndex = rvHandles.indexOf(handle);
if (elIndex > -1) {
  rvHandles.splice(elIndex, 1);
}

rvHandles.splice(0, 0, handle);

// maximum recently viewed items = 6
const maxItemsNumber = 6;
if (rvHandles.length > maxItemsNumber) {
  rvHandles.pop();
}

setCookie('fr_rv', rvHandles.join('|'));
